import { Component, Input,Inject } from '@angular/core';
import {MatDialog, MatDialogActions, MatDialogClose, MatDialogContent,MAT_DIALOG_DATA} from '@angular/material/dialog';
import { PersonInterface ,DefaultPersonTable } from '../person-interface';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-person-information',
  standalone: true,
  imports: [MatDialogContent
    ,MatDialogActions
    ,MatDialogClose
    ,NgIf
  ],
  template: `
  <h2 mat-dialog-title>Person information</h2>
<mat-dialog-content class="mat-typography">
    <div *ngIf="data.person">
      <h2>Person Information</h2>
      <p><strong>ID:</strong> {{ data.person.id }}</p>
      <p><strong>Owner ID:</strong> {{ data.person.owner_id }}</p>
      <p><strong>Second Owner ID:</strong> {{ data.person.second_owner_id }}</p>
      <p><strong>Parent ID:</strong> {{ data.person.parent_id }}</p>
      <p><strong>Level:</strong> {{ data.person.level }}</p>
      <p><strong>Name:</strong> {{ data.person.name }}</p>
      <p><strong>Latin Name:</strong> {{ data.person.latin_name }}</p>
      <p><strong>Start of Family Name:</strong> {{ data.person.start_of_family_name }}</p>
      <p><strong>Birthdate:</strong> {{ data.person.birthdate}}</p>
      <p><strong>Deathdate:</strong> {{ data.person.deathdate}}</p>
      <p><strong>Notes:</strong> {{ data.person.notes }}</p>
      <p><strong>Last Update:</strong> {{ data.person.lastupdate}}</p>
      <p><strong>Mother Name:</strong> {{ data.person.mother_name }}</p>
      <p><strong>Mother ID:</strong> {{ data.person.mother_id }}</p>
      <p><strong>Country ID:</strong> {{ data.person.country_id }}</p>
      <p><strong>City ID:</strong> {{ data.person.city_id }}</p>
      <p><strong>Root Clan ID:</strong> {{ data.person.rootClan_id }}</p>
      <p><strong>Root Clan Name:</strong> {{ data.person.rootClan_name }}</p>
      <p><strong>Gender:</strong> {{ data.person.gender }}</p>
      <button (click)="copyIdToClipboard()">Copy ID</button>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>close</button>
</mat-dialog-actions>
  `,
  styleUrl: './person-information.component.css'
})
export class PersonInformationComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { person: PersonInterface }) {

  }
  copyIdToClipboard() {
    if (this.data.person && this.data.person.id) {
      navigator.clipboard.writeText(this.data.person.id)
        .then(() => {
          console.log('ID copied to clipboard');
        })
        .catch(err => {
          console.error('Failed to copy ID: ', err);
        });
    }
  }
}
